var exports = {
  "kL": "x4ddf2309--cc8c1f--container",
  "Sl": "x4ddf2309--cc8c1f--image",
  "h_": "x4ddf2309--cc8c1f--description",
  "o1": "x4ddf2309--cc8c1f--actions",
  "tb": "x4ddf2309--cc8c1f--catalog-link",
};

module.exports = exports;
